<template>
  <nav>
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="termsOfService" />
  </nav>
</template>

<script>
    import { getGdpr } from '../../api/gdprApi'
    import AlertMessages  from '../../components/AlertMessages'

    export default {
        components: {
            AlertMessages
        },
        data(){
            return{
                termsOfService: '',
                alertType: '',
                alertMsg: '',
                alertValue: false,
                language: window.$cookies.get('language') ? window.$cookies.get('language') : 'en',
            }
        },
        created() {
            this.getGdpr()
        },
        methods: {
            async getGdpr() {
                try {
                    const response = await getGdpr(this.language)
                    if(response){
                        if(response.status == 200) {
                            this.termsOfService = response.data.meta.terms
                        }
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        this.alertType = 'error';
                        this.alertMsg =  'serverError'
                    } 
                }
            },
        },
    }
</script>
